// import 'element-closest/browser';

export default class youtubeVideoPopin {
    constructor() {
        this.containers = document.querySelectorAll('.video-item');
        if (this.containers === null) return;

        this.linksVideo = [];
        this.btnsCloseVideo = [];
        this.btnsOpenVideo = [];
        this.player = null;

        this.importYoutubeScript();

        Array.from(this.containers).forEach((container) => {
            if (container.querySelector('.js-open-video')) {
                this.btnsOpenVideo.push(container.querySelector('.js-btn-play'));
                this.linksVideo.push(container.querySelector('.js-open-video'));
                this.btnsCloseVideo.push(container.querySelector('.js-btn-close'));
            }

            this.sizeWindow(container);
            window.addEventListener('resize', this.sizeWindow(container));
        });


        Array.from(this.linksVideo).forEach((linkVideo) => {
            linkVideo.addEventListener('click', this.videoAppear.bind(this));
        });

        Array.from(this.btnsOpenVideo).forEach((btnOpenVideo) => {
            btnOpenVideo.addEventListener('click', this.videoAppear.bind(this));
        });

        Array.from(this.btnsCloseVideo).forEach((btnCloseVideo) => {
            btnCloseVideo.addEventListener('click', this.videoDisappear.bind(this));
        });
    }



    sizeWindow(container) {
        if (document.documentElement.clientWidth > 960) return;

        let illustElement = container.querySelector('.js-open-video');

        if (!illustElement || illustElement.getAttribute('data-video-id') === null) return;

        window.onYouTubePlayerAPIReady = () => {
            this.onYouTubeIframeAPIReady(illustElement);
        }
    }

    videoAppear(event) {
        event.stopPropagation();
        event.currentTarget.closest('.js-popin-video').classList.add('video-appear');

        let illustElement = event.currentTarget.closest('.js-popin-video').querySelector('.js-open-video');

        if (!illustElement || illustElement.getAttribute('data-video-id') === null) return;

        if (this.player !== null) return this.player.playVideo();

        this.onYouTubeIframeAPIReadyPlay(illustElement)
    }


    videoDisappear(event) {
        event.currentTarget.parentElement.parentElement.parentElement.classList.remove('video-appear');
        let illustElement = event.currentTarget.closest('.js-popin-video').querySelector('.js-open-video');
        if (illustElement.getAttribute('data-video-id') === null) return;

        this.stopVideo();
        this.player = null;
    }

    onYouTubeIframeAPIReadyPlay(elEvent) {
        const player = elEvent.parentElement.querySelector('.player-yt').getAttribute('id');
        const videoID = elEvent.getAttribute('data-video-id');

        this.player = new YT.Player(player, {
            height: '670',
            width: '1600',
            videoId: videoID,
            events: {
                'onReady': this.onPlayerReady
            }
        });
    }

    onPlayerReady(event) {
        event.target.playVideo();
    }

    stopVideo() {
        if(this.player !== null ) this.player.stopVideo();
    }

    importYoutubeScript() {
        if (typeof (window.YT) === 'undefined' || typeof (YT) === 'undefined' || typeof (YT.Player) === 'undefined') {

            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";

            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        }
    }
}
